import logger from './logger';

class FacebookSDK {
    init() {
        return new Promise((resolve, reject) => {
            try {
                // INFO: wait for facebook sdk to initialize before starting the react app
                window.fbAsyncInit = function () {
                    try {
                        window.FB.init({
                            appId: '5973750809389166',
                            autoLogAppEvents: true,
                            xfbml: true,
                            version: 'v17.0',
                        });
                        resolve();
                    } catch (error) {
                        logger.error('Error initializing Facebook SDK:', error);
                        reject(error);
                    }
                };

                // INFO: load facebook sdk script
                (function (d, s, id) {
                    try {
                        var js,
                            fjs = d.getElementsByTagName(s)[0];
                        if (d.getElementById(id)) {
                            return;
                        }
                        js = d.createElement(s);
                        js.id = id;
                        js.src = 'https://connect.facebook.net/en_US/sdk.js';
                        fjs.parentNode.insertBefore(js, fjs);
                    } catch (error) {
                        logger.error('Error loading Facebook SDK script:', error);
                        reject(error);
                    }
                })(document, 'script', 'facebook-jssdk');

                // INFO: load facebook business sdk script for WhatsApp Embedded Flow
                (function (d, s, id) {
                    try {
                        var js,
                            fjs = d.getElementsByTagName(s)[0];
                        if (d.getElementById(id)) {
                            return;
                        }
                        js = d.createElement(s);
                        js.id = id;
                        js.async = true;
                        js.defer = true;
                        js.crossOrigin = 'anonymous';
                        js.src = 'https://connect.facebook.net/en_US/business.sdk.js';
                        fjs.parentNode.insertBefore(js, fjs);
                    } catch (error) {
                        logger.error('Error loading Facebook Business SDK script:', error);
                        // Don't reject here as it's not critical for regular Facebook functionality
                    }
                })(document, 'script', 'facebook-business-sdk');
            } catch (error) {
                logger.error('Error in Facebook SDK initialization:', error);
                reject(error);
            }
        });
    }

    getLoginStatus() {
        return new Promise(resolve => {
            window.FB.getLoginStatus(response => {
                resolve(response);
            });
        });
    }

    login() {
        return new Promise(resolve =>
            window.FB.login(
                response => {
                    resolve(response);
                },
                {
                    config_id: '649437327208138',
                    response_type: 'code',
                    auth_type: 'rerequest',
                },
            ),
        );
    }

    loginMetaBusiness() {
        return new Promise(resolve =>
            window.FB.login(
                response => {
                    resolve(response);
                },
                {
                    config_id: '8492726760741889',
                    response_type: 'code',
                    auth_type: 'rerequest',
                    override_default_response_type: true,
                },
            ),
        );
    }
}

export default new FacebookSDK();
